import React, { createContext, ReactNode, useReducer } from 'react';
import { SET_PATIENT_NUMBER, SET_BEREAVEMENT_TABLE } from './constants';

type AppBereavementContextProviderProps = {
  children: ReactNode;
};

type AppBereavementContext = {
  patientNumber: string | null;
  showTable: boolean;
  dispatch?: any;
};

type AppBereavementContextState = {
  patientNumber: string | null;
  showTable: boolean;
};

const initialState = {
  patientNumber: null,
  showTable: false,
};

const initAppBereavementContext = {
  patientNumber: null,
  showTable: false,
};

export const AppBereavementContextReducer = (
  state: AppBereavementContextState,
  action: { type: string; payload: mumms.ComponentName | any },
) => {
  let newState = { ...state };
  switch (action.type) {
    case SET_PATIENT_NUMBER:
      newState.patientNumber = action.payload;
      break;
    case SET_BEREAVEMENT_TABLE:
      newState.showTable = action.payload;
      break;
    default:
      newState = state;
      break;
  }
  return newState;
};

export const AppBereavementContext = createContext<AppBereavementContext>(
  initAppBereavementContext as AppBereavementContext,
);
export const AppBereavementContextProvider = ({
  children,
}: AppBereavementContextProviderProps) => {
  const [{ patientNumber, showTable }, dispatch] = useReducer(
    AppBereavementContextReducer,
    initialState,
  );
  return (
    <AppBereavementContext.Provider
      value={{
        patientNumber,
        showTable,
        dispatch,
      }}
    >
      {children}
    </AppBereavementContext.Provider>
  );
};

export default AppBereavementContextProvider;
